import { useState, useEffect } from "react";

export default function Splash({ onDone }) {
  const [phase, setPhase] = useState(0);
  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 200);
    const t2 = setTimeout(() => setPhase(2), 1000);
    const t3 = setTimeout(() => onDone(), 2200);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [onDone]);

  return (
    <div style={{
      height: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(135deg, #1a1a1a, #2d2d2d)", flexDirection: "column",
    }}>
      <div style={{
        fontSize: 72,
        transform: phase >= 1 ? "scale(1) rotate(0deg)" : "scale(0) rotate(-180deg)",
        transition: "all 0.6s cubic-bezier(0.68, -0.55, 0.27, 1.55)",
        filter: phase >= 1 ? "none" : "blur(10px)",
      }}>💰</div>
      <div style={{
        color: "#fff", fontSize: 32, fontWeight: 900, marginTop: 16,
        opacity: phase >= 2 ? 1 : 0,
        transform: phase >= 2 ? "translateY(0)" : "translateY(20px)",
        transition: "all 0.5s ease",
      }}>MonArgent</div>
      <div style={{
        color: "#F39C12", fontSize: 12, fontWeight: 700, letterSpacing: 4,
        textTransform: "uppercase", marginTop: 8,
        opacity: phase >= 2 ? 1 : 0, transition: "all 0.5s ease 0.2s",
      }}>Gérez votre business</div>
      <div style={{
        position: "absolute", bottom: 40, width: 50, height: 4,
        borderRadius: 2, background: "#333", overflow: "hidden",
        opacity: phase >= 1 ? 1 : 0,
      }}>
        <div style={{
          width: "100%", height: "100%", background: "#F39C12", borderRadius: 2,
          transform: `scaleX(${phase >= 2 ? 1 : 0.2})`, transformOrigin: "left",
          transition: "transform 1.2s ease",
        }} />
      </div>
    </div>
  );
}
